// Components state
export const SET_LOADING = "SET_LOADING";
export const SET_NAVBAR_VISIBILITY = "SET_NAVBAR_VISIBILITY";
export const SET_SHOW_POPUP = "SET_SHOW_POPUP";
// Subscription page top banner
export const GET_SUBSCRIPTION_BANNER = "GET_SUBSCRIPTION_BANNER";
// User
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_PAYMENT_INFO = "SET_PAYMENT_INFO";
export const SET_SHIPPING_ADRESS = "SET_SHIPPING_ADRESS";
// Cart
export const SET_USER_CART = "SET_USER_CART";
export const SET_ORIGINAL_USER_CART = "SET_ORIGINAL_USER_CART";
export const SET_MISSING_ADDONS = "SET_MISSING_ADDONS";
export const SET_CURRENT_PRODUCT = "SET_CURRENT_PRODUCT";
export const SET_FLAVOR_AMOUNT = "SET_FLAVOR_AMOUNT";
export const SET_ATTRIBUTE = "SET_ATTRIBUTE";
export const DELETE_USER_CART_ITEM = "DELETE_USER_CART_ITEM";
export const SET_QUANTITY = "SET_QUANTITY";
export const SET_BAGS_INFO = "SET_BAGS_INFO";
export const SET_ADDON_FLAVOR = "SET_ADDON_FLAVOR";
export const SET_ADDON_ATTRIBUTE = "SET_ADDON_ATTRIBUTE";
export const SET_ADDON_QUANTITY = "SET_ADDON_QUANTITY";
export const SET_ADDON_BAGS_INFO = "SET_ADDON_BAGS_INFO";
export const SET_ORIGINAL_MISSING_ADDON = "SET_ORIGINAL_MISSING_ADDON";
// Pricing
export const SET_PRICING = "SET_PRICING";
export const SET_DISCOUNT = "SET_DISCOUNT";
// Orders
export const SET_ORDER_DETAILS = "SET_ORDER_DETAILS";
export const SET_ORDER_STATUS_DATA = "SET_ORDER_STATUS_DATA";
export const SET_NEXT_ORDER_DATES = "SET_NEXT_ORDER_DATES";
export const UPDATE_NEXT_CADENCE = "UPDATE_NEXT_CADENCE";
export const SET_PREVIOUS_CADENCE = "SET_PREVIOUS_CADENCE";
export const UPDATE_NEXT_BILL_DATE = "UPDATE_NEXT_BILL_DATE";
export const SET_FUTURE_ORDERS = "SET_FUTURE_ORDERS";
// getItNow
export const SET_GIN_LOADING = "SET_GIN_LOADING";
export const SET_GIN_USERCART = "SET_GIN_USERCART";
export const CLEAR_GIN_USERCART = "CLEAR_GIN_USERCART";
export const SET_GIN_PRICING = "SET_GIN_PRICING";
export const SET_GIN_DISCOUNT_STR = "SET_GIN_DISCOUNT_STR";
export const SET_GIN_RECURRING_DISCOUNT_STR = "SET_GIN_RECURRING_DISCOUNT_STR";
export const SET_GIN_NEXT_ORDER = "SET_GIN_NEXT_ORDER";
// Dietitian
export const SET_REGISTERED_DIETITIAN = "SET_REGISTERED_DIETITIAN";
export const SET_MACRO_ANSWERS = "SET_MACRO_ANSWERS";
export const SET_MACRO_RESULT = "SET_MACRO_RESULT";
// referalInfo
export const SET_REFERAL_INFO = "SET_REFERAL_INFO";
export const SET_UNCOVERED_FRIENDS = "SET_UNCOVERED_FRIENDS";
export const SET_PURCHASE_PEOPLE = "SET_PURCHASE_PEOPLE";
export const SET_STORED_REFERRALS = "SET_STORED_REFERRALS";
export const SET_HAS_SHARED = "SET_HAS_SHARED";
// Order history
export const SET_ORDERS = "SET_ORDERS";
export const SET_IS_COMPLETE = "SET_IS_COMPLETE";
export const SET_FETCHING_MORE = "SET_FETCHING_MORE";
export const SET_NEXT_INDEX = "SET_NEXT_INDEX";
export const SET_THIS_ORDER_DETAIL = "SET_THIS_ORDER_DETAIL";
// Account settings
export const SET_ACCOUNT_LOADING = "SET_ACCOUNT_LOADING";
export const SET_USER_ACCOUNT = "SET_USER_ACCOUNT";
export const SET_ORIGINAL_USER_ACCOUNT_DATA = "SET_ORIGINAL_USER_ACCOUNT_DATA";
export const SET_COMMUNICATION_PREFS = "SET_COMMUNICATION_PREFS";
// My profile
export const SET_ORIGINAL_ANSWERS = "SET_ORIGINAL_ANSWERS";
export const SET_SELECTED_ANSWERS = "SET_SELECTED_ANSWERS";
export const SET_QUIZ_OPTIONS = "SET_QUIZ_OPTIONS";
export const EDIT_MODEL_OBJ = "EDIT_MODEL_OBJ";
export const CHANGE_PRODUCTS_STATUS = "CHANGE_PRODUCTS_STATUS";
export const CHANGE_PRODUCTS = "CHANGE_PRODUCTS";
export const CHANGE_METRICS = "CHANGE_METRICS";
// Check ReduxStore
export const SET_HOME = "SET_HOME";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const SET_PROFILE = "SET_PROFILE";
export const SET_DIETITIAN = "SET_DIETITIAN";
export const SET_REFERAL = "SET_REFERAL";
export const SET_HISTORY = "SET_HISTORY";
export const SET_SETTINGS = "SET_SETTINGS";
